export function formatNumber(number, minimumFractionDigits = 2) {
  return number.toLocaleString('nl-NL', {
    style: 'decimal',
    minimumFractionDigits
  });
}
